import routes from './routes';
import { SetRoutes } from 'components';

const AcademyArticlesPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default AcademyArticlesPages;
